import React from 'react';
import * as Styles from './NewMacroStep4.style';
import { StepLabel } from 'components/step-label/StepLabel';
import Input from 'components/input';

const NewMacroStep4 = ({ formikProp, edited }) => {
  const { values, handleChange, errors, touched, handleBlur } = formikProp;
  return (
    <Styles.NewMacroStep4SC>
      <StepLabel id="ST4" stepCount={'Step 4'}>
        {edited ? `Add or edit keywords, which helps staff find this macro?` : `Add some keywords`}
      </StepLabel>
      <Styles.StepDescription>
        When you are going to reply to a client's message, these keywords, as well as the content you specify below,
        will be searched in order to give you a response suggestion. Separate the keywords just by a blank space; only
        letters and numbers are accepted.
      </Styles.StepDescription>
      <Styles.SubmitReply>
        <Input
          name={'keywords'}
          value={values['keywords']}
          placeholder={'Keywords'}
          onChange={handleChange}
          onBlur={handleBlur}
          error={errors['keywords']}
          touched={touched['keywords']}
        />
      </Styles.SubmitReply>
    </Styles.NewMacroStep4SC>
  );
};
export default NewMacroStep4;
